$(document).ready(function () {

    /* CALCULATOR CONFIGURATION */

    // if chain and width = 16 and height = 12 then disable 'add to cart' button. 
    // if chain and width = 16 and height = 16 then disable 'add to cart' button. 

    /* END CALCULATOR CONFIGURATION */

});